import { render, staticRenderFns } from "./allowanceDialog.vue?vue&type=template&id=cf4029b8&scoped=true&"
import script from "./allowanceDialog.vue?vue&type=script&lang=js&"
export * from "./allowanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./allowanceDialog.vue?vue&type=style&index=0&id=cf4029b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4029b8",
  null
  
)

export default component.exports